import React, { Component } from 'react';
import Buttons from '../../../UI/Buttons';
// import Wrp from '../../../hoc/Wrp/Wrp';

class Actions extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
        const {colData,id} = this.props;
        return(
            <td key={"column"+id}>   
                <Buttons buttonList={colData} key={"btn"+id}/>
            </td>
        );
    }
}

export default Actions;